<template>
  <v-main style="height: 100%">
    <HeaderLabel label="Motor Model"></HeaderLabel>
    <v-layout justify-center mt-5>
      <v-flex pa-4>
        <v-layout justify-space-between mb-7>
          <v-flex shrink>
            <v-layout>
              <v-flex>
                <v-layout>
                  <v-flex>
                    <FilterDisplay @onChange="filter = $event"></FilterDisplay>
                  </v-flex>
                  <v-flex>
                    <v-text-field
                      class="mr-2"
                      v-model="keyword"
                      dense
                      outlined
                      label="Keyword"
                    ></v-text-field>
                  </v-flex>
                  <v-flex>
                    <v-btn
                      @click="search"
                      depressed
                      dense
                      large
                      color="#c80404"
                      class="text-start white--text"
                    >
                      Search
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex shrink>
            <v-btn
              @click="clickRow({})"
              depressed
              large
              color="#c80404"
              class="pr-7 text-start white--text"
            >
              <v-icon class="mr-2">mdi-plus</v-icon>
              Add
            </v-btn>
          </v-flex>
        </v-layout>
        <v-row>
          <v-col cols="12">
            <v-data-table :items="motorList" style="border: solid 1px black">
              <template v-slot:header="{}">
                <thead class="white--text" style="background-color: #555555">
                  <tr>
                    <td>Image</td>
                    <td>Name</td>
                    <td>Description</td>
                    <td>Brand</td>
                    <td>CC</td>
                    <td>Year</td>
                    <td></td>
                  </tr>
                </thead>
              </template>
              <template v-slot:item="{ item }">
                <tr :class="{ itemHide: !item.is_active }">
                  <td align="center">
                    <v-img
                      width="100px"
                      :src="
                        item.image && item.image[0]
                          ? item.image[0]
                          : require('../assets/img/no-image.png')
                      "
                    ></v-img>
                  </td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.description }}</td>
                  <td align="center">
                    <v-img
                      width="100px"
                      :src="
                        item.brand_id
                          ? convertBrand(item.brand_id)
                          : require('../assets/img/no-image.png')
                      "
                    ></v-img>
                  </td>
                  <td>{{ item.cc_id ? convertCC(item.cc_id) : item.cc_id }}</td>
                  <td>{{ item.year }}</td>
                  <td>
                    <a @click="clickRow(item)">Edit</a> |
                    <a
                      :class="[item.is_active ? 'red--text' : 'green--text']"
                      @click="toggleDisplay(item)"
                    >
                      {{ item.is_active ? "Hide" : "Show" }}
                    </a>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" max-width="1000" persistent>
      <div v-if="dialog" style="background-color: white">
        <MotorModelForm
          @SucessClick="SucessClick"
          :model="row"
        ></MotorModelForm>
      </div>
    </v-dialog>
  </v-main>
</template>

<script>
import HeaderLabel from "../components/HeadetLabel";
import MotorModelForm from "../components/MotorModelForm";
import FilterDisplay from "../components/FilterDisplay";
import { mapState } from "vuex";
import Service from "../services";
export default {
  data() {
    return {
      row: {},
      keyword: null,
      filter:1,
      dialog: false,
    };
  },
  components: {
    MotorModelForm,
    FilterDisplay,
    HeaderLabel,
  },
  methods: {
    search() {
      this.$store.dispatch("Motor/getMotorList", {keyword:this.keyword, display:this.filter});
    },
    clickRow(item) {
      this.row = item;
      this.dialog = true;
    },
    SucessClick() {
      this.dialog = false;
      this.$store.dispatch("Motor/getMotorList", {keyword:this.keyword, display:this.filter});
    },
    async toggleDisplay(item) {
      let answer = await this.$swal.fire({
        ...this.$swalDel,
        text: `Are you sure to ${
          item.is_active ? "hide" : "show"
        }  this model?`,
      });
      if (answer.isConfirmed) {
        this.$store.dispatch("Loading/onSetLoading", true);
        Service.motor.display(item).then((res) => {
          if (res.status === 200) {
            this.$store.dispatch("Motor/getMotorList", {keyword:this.keyword, display:this.filter});
            this.$store.dispatch("Loading/onSetLoading", false);
          }
        });
      }
    },
    convertBrand(id) {
      let model = this.brandList.find((x) => x.id === id);
      return model ? model.image[0] : ''; 
    },
    convertCC(id) {
      let model = this.ccList.find((x) => x.id === id);
      return model ? model.name : '';
    },
  },
  computed: {
    ...mapState({
      motorList: (state) => state.Motor.motorList,
      brandList: (state) => state.Brand.brandList,
      ccList: (state) => state.CC.ccList,
    }),
  },
  async created() {
    await this.$store.dispatch("Motor/getMotorList", {keyword:this.keyword, display:this.filter});
  },
};
</script>

<style>
</style>